export default "__VITE_ASSET__2bG11Uzh__"